export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">关于飞飞漫画网</h2>
            <p className="text-foreground-500 text-sm">用心做好每一个细节，只为给漫画爱好者最好的免费阅读体验</p>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-8 space-y-5">
            <p className="text-foreground-600 text-sm leading-relaxed">
              飞飞漫画网创建于 2020 年，是专注于免费漫画在线阅读的专业平台。我们致力于为广大漫画爱好者提供最丰富、最高质量的漫画资源，涵盖国漫、日漫、韩漫等主流品类，累计收录超过 12,000 部漫画作品，每日更新 300+ 话，服务超过 500 万在线读者。
            </p>
            <p className="text-foreground-600 text-sm leading-relaxed">
              我们自主研发的下拉式阅读引擎，从根本上解决了传统翻页阅读的卡顿问题，让读者可以像刷短视频一样流畅地追更漫画。无论是移动端还是桌面端，飞飞漫画网都能提供一致的高品质阅读体验。
            </p>
            <p className="text-foreground-600 text-sm leading-relaxed">
              未来，飞飞漫画网将继续加大在内容审核、版权保护和阅读体验方面的投入，与更多优秀漫画创作者和平台合作，为读者带来更多优质免费漫画。我们相信，好的漫画应该被更多人看到。
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 pt-4 border-t border-background-200/50">
              {[
                { value: '2020年', label: '创立时间' },
                { value: '12,000+', label: '漫画总量' },
                { value: '500万+', label: '在线读者' },
                { value: '300+/日', label: '更新频率' },
              ].map((item) => (
                <div key={item.label} className="text-center">
                  <div className="font-heading text-lg text-primary-500">{item.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{item.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}